import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import type BetaToggleService from 'scaleflow/services/beta-toggle';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { assignTeamsToInitiative } from 'scaleflow/utils/assign-teams-to-initiative';

export default class OperationsTeamsTeamInitiativesController extends Controller {
  @service declare betaToggle: BetaToggleService;
  @service declare store: any;
  @service('organisation') declare orgService: any;

  @tracked initiativeFormIsVisible = false;

  queryParams = [
    'grouping',
    'statuses',
    'themes',
    'sources',
    'product_managers',
    'teams',
    'show_grouping',
    'start_date',
    'end_date',
    'columns',
  ];

  @tracked grouping = null;
  @tracked statuses = [];
  @tracked themes = [];
  @tracked sources = [];
  @tracked productManagers = [];
  @tracked teams = [];
  @tracked columns: string[] = [];
  @tracked roadmaps = [];
  @tracked goals = [];

  showColumn(column: { show?: boolean; label: string }) {
    if (this.columns.length === 0) {
      if (column.show !== undefined) return column.show;
      return true;
    } else {
      return this.columns.includes(column.label);
    }
  }

  get columnOptions() {
    const columns = [...this.betaToggle.columnOptions];
    columns.forEach((item: { show?: boolean; label: string }) => {
      item.show = this.showColumn(item);
    });
    return columns.slice();
  }

  @action
  toggleInitiativeForm(val?: boolean) {
    if (val !== undefined) this.initiativeFormIsVisible = val;
    else this.initiativeFormIsVisible = !this.initiativeFormIsVisible;
  }

  @action
  async setTeamOnInitiative(initiative: any) {
    await assignTeamsToInitiative(this.store, this.orgService, initiative, [
      String((this.model as any).id),
    ]);
  }
}
